export default __webpack_public_path__ + "static/media/IMG_2704 copie.cc167619.jpg";